import React from 'react';
import { ShieldCheckIcon, SparklesIcon, HeartIcon, ClockIcon } from 'lucide-react';
export const FeaturesSection = () => {
  const features = [{
    name: 'Safe & Clean',
    description: 'All our equipment is thoroughly sanitized between each use and made with child-safe materials.',
    icon: ShieldCheckIcon,
    color: 'bg-primary-100 text-primary-600'
  }, {
    name: 'Toddler Approved',
    description: 'Designed specifically for little ones aged 6 months to 5 years with soft edges and engaging elements.',
    icon: HeartIcon,
    color: 'bg-primary-100 text-primary-600'
  }, {
    name: 'Easy Setup',
    description: 'We handle all the setup and takedown so you can focus on enjoying the party with your little one.',
    icon: SparklesIcon,
    color: 'bg-primary-100 text-primary-600'
  }, {
    name: 'Flexible Booking',
    description: 'Need it for a few hours or the whole day? Totally fine! Just note our last pickup is 7:00 PM.',
    icon: ClockIcon,
    color: 'bg-primary-100 text-primary-600'
  }];
  return <div id="about" className="bg-white py-12 md:py-20" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="text-center" data-id="element-149">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-150">
            Why Parents Love Us
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-500" data-id="element-151">
            Creating magical moments for your little ones with safe, clean, and
            engaging play experiences.
          </p>
        </div>
        <div className="mt-12" data-id="element-152">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-153">
            {features.map(feature => <div key={feature.name} className="pt-6" data-id="element-154">
                <div className="flow-root bg-primary-50 rounded-lg px-6 pb-8 h-full" data-id="element-155">
                  <div className="-mt-6" data-id="element-156">
                    <div data-id="element-157">
                      <span className={`inline-flex items-center justify-center p-3 rounded-md shadow-lg ${feature.color}`} data-id="element-158">
                        <feature.icon className="h-6 w-6" aria-hidden="true" data-id="element-159" />
                      </span>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight" data-id="element-160">
                      {feature.name}
                    </h3>
                    <p className="mt-2 text-base text-gray-500" data-id="element-161">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};